import React, { useEffect, useState } from "react";
import { testimonials } from "../mock";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import SectionHeading from "./SectionHeading";

export default function Testimonials() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % testimonials.length), 6000);
    return () => clearInterval(id);
  }, []);

  const prev = () => setI((v) => (v - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((v) => (v + 1) % testimonials.length);
  const t = testimonials[i];

  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-60" />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8">
        <SectionHeading eyebrow="Client stories" title="Trusted by teams who can’t afford downtime." />

        <div className="mt-14 relative">
          <Quote className="absolute -top-6 left-0 h-16 w-16 text-brand-100" />
          <div key={t.id} className="animate-fade-up">
            <p className="relative font-display text-2xl lg:text-[28px] leading-[1.4] text-slate-800">
              “{t.quote}”
            </p>
            <div className="mt-8 flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-brand-600 to-brand-800 text-white font-display font-bold grid place-items-center">
                {t.name.split(" ").map((n) => n[0]).slice(0,2).join("")}
              </div>
              <div>
                <div className="font-semibold text-slate-900">{t.name}</div>
                <div className="text-[13px] text-slate-500">{t.role}</div>
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex gap-2">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 bg-brand-700" : "w-4 bg-slate-300"}`}
                  aria-label={`Testimonial ${idx + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button onClick={prev} className="h-10 w-10 rounded-full border border-slate-300 grid place-items-center hover:border-brand-500 hover:text-brand-700 transition-colors" aria-label="Previous">
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button onClick={next} className="h-10 w-10 rounded-full border border-slate-300 grid place-items-center hover:border-brand-500 hover:text-brand-700 transition-colors" aria-label="Next">
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
